import { MachineEvent } from "@/model/data/machineEvents/MachineEvent";
import { UserEvent } from "@/model/data/userEvents/UserEvent";
import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";

export class GetMachineSmartLockEventsHistoryResData extends ApiGenericResponse {
    machineEvents: Array<MachineEvent>;
    userEvents: Array<UserEvent>;
    totalEvents: number = 0;

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload) {
            this.parse(response.data.Payload);
        }
    }

    public parse(obj: any) {
        if (obj.UserEvents) {
            this.userEvents = new Array<UserEvent>();
            obj.UserEvents.forEach((userEvent) => {
                let ue = new UserEvent();
                ue.parse(userEvent);
                this.userEvents.push(ue);
            });
        }
        if (obj.MachineEvents) {
            this.machineEvents = new Array<MachineEvent>();
            obj.MachineEvents.forEach((machineEvent) => {
                let me = new MachineEvent();
                me.parse(machineEvent);
                this.machineEvents.push(me);
            });
        }

        if (obj.TotalEvents) this.totalEvents = obj.TotalEvents;
    }
}
